import { finalize, tap } from 'rxjs/operators';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ModemChoiceService } from '../modem-choice.service';
import { VoipCredentials } from '../models/voip-credentials.model';

@UntilDestroy()
@Component({
  selector: 'mprd-modem-choice-voip-credentials',
  templateUrl: './modem-choice-voip-credentials.component.html',
})
export class ModemChoiceVoipCredentialsComponent {
  @Input() open = false;
  @Output() openChange = new EventEmitter<boolean>();
  pending = false;
  credentials: VoipCredentials | undefined;

  @Input() set subscriberNumber(subscriberNumber: string) {
    if (!subscriberNumber) return;
    this.pending = true;
    this.credentials = undefined;
    this.modemChoiceService
      .generateVoipCredentials(subscriberNumber)
      .pipe(
        tap((credentials) => (this.credentials = credentials)),
        finalize(() => (this.pending = false)),
        untilDestroyed(this),
      )
      .subscribe();
  }

  constructor(private modemChoiceService: ModemChoiceService) {}

  onClose(): void {
    if (this.pending) return;
    this.close();
  }

  onCopy(value: string): void {
    navigator.clipboard.writeText(value).catch(console.error);
  }

  private close(): void {
    this.open = false;
    this.openChange.emit(false);
  }
}
